import { Box } from '@mui/material';
import { Check } from 'lucide-react';

/** Size of the tick, in CSS pixels; also the width of its column. */
const CHECK_SIZE_PX = 16;

/**
 * The mark on the row a list is currently showing, at the end of that row.
 * A tick rather than a tint alone, so the choice in force survives a glance
 * at any contrast.
 *
 * Rendered as a fixed column whether or not it is marked, so a list does not
 * shuffle sideways between its rows.
 */
export default function MenuCheck({
    selected,
}: {
    readonly selected: boolean;
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexShrink: 0,
                width: CHECK_SIZE_PX,
                color: 'primary.main',
            }}
            aria-hidden
        >
            {selected ? <Check size={CHECK_SIZE_PX} /> : null}
        </Box>
    );
}
